/**
 * A running bar for a wait whose length nobody knows (1.100.0).
 *
 * From use, about the day card on a long route: "zumindest sollte dann ein
 * Fortschrittsbalken angezeigt werden." A request has no progress to tell:
 * the time goes to the server's reading of the route, not to the bytes of
 * the answer. A bar that filled up would therefore be a guess; this one runs
 * and says only that something is under way.
 *
 * **It is the bar of the start screen**, not a second one: `.loading-bar`
 * shares its rules with `.startanzeige__balken` (`app.css`), whose markup
 * also stands in `index.html` and keeps its class there.
 */
export function LoadingBar({ label }: { label: string }) {
  return <span className="loading-bar" role="progressbar" aria-label={label} data-loading-bar="" />
}
